export enum GenderIdentity {
    Female = 'Female',
    Male = 'Male',
    TransgenderMan = 'TransgenderMan',
    TransgenderWoman = 'TransgenderWoman',
    DoNotIdentifyAsAny = 'DoNotIdentifyAsAny',
    DoNotIdentifyAsMaleOrFemale = 'DoNotIdentifyAsMaleOrFemale',
    PreferNotToAnswer = 'PreferNotToAnswer'
}
